import { render, staticRenderFns } from "./CatalogoCartas.vue?vue&type=template&id=d8d010f2&scoped=true"
import script from "./CatalogoCartas.vue?vue&type=script&lang=js"
export * from "./CatalogoCartas.vue?vue&type=script&lang=js"
import style0 from "./CatalogoCartas.vue?vue&type=style&index=0&id=d8d010f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d010f2",
  null
  
)

export default component.exports